import React from 'react';

// Deterministic gradient avatar based on agent name
function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

const PALETTES = [
  ['#FF6B1A', '#FFB17A'],
  ['#39FF14', '#A8FFCB'],
  ['#FF6B1A', '#39FF14'],
  ['#FFB17A', '#39FF14'],
  ['#FF6B1A', '#FF8A4A'],
  ['#39FF14', '#22D3EE'],
  ['#FF6B1A', '#F0E68C'],
];

export const AgentAvatar = ({ name = '?', size = 44, className = '' }) => {
  const seed = hash(name);
  const [a, b] = PALETTES[seed % PALETTES.length];
  const initials = name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase();
  return (
    <div
      className={`relative grid place-items-center rounded-2xl ${className}`}
      style={{
        width: size, height: size,
        background: `radial-gradient(circle at 30% 30%, ${a}, ${b} 70%, #0B0F17 110%)`,
        boxShadow: `0 0 0 1px rgba(255,107,26,0.18), 0 6px 20px rgba(255,107,26,0.12)`,
      }}
    >
      <span className="display font-semibold text-white text-sm tracking-tight">{initials}</span>
    </div>
  );
};
